import { render, staticRenderFns } from "./EditTransferCampaign.vue?vue&type=template&id=14024bb5&scoped=true&"
import script from "./EditTransferCampaign.vue?vue&type=script&lang=js&"
export * from "./EditTransferCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14024bb5",
  null
  
)

export default component.exports